
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/onedrive",
      function () {
        return require("private-next-pages/destinations/onedrive.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/onedrive"])
      });
    }
  